// extracted by mini-css-extract-plugin
export default {"title":"Header_title__7eJsW","container":"Header_container__S4gJq","btn":"Header_btn__gAe3H","action_txt":"Header_action_txt__yxiQb","formGrid":"Header_formGrid__14cnC"};